import { render, staticRenderFns } from "./CorporateTemplate.vue?vue&type=template&id=85a4514c&scoped=true"
import script from "./CorporateTemplate.vue?vue&type=script&lang=js"
export * from "./CorporateTemplate.vue?vue&type=script&lang=js"
import style0 from "./CorporateTemplate.vue?vue&type=style&index=0&id=85a4514c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a4514c",
  null
  
)

export default component.exports